export const mockupDevicesContainerStyle = {
  position: 'relative',
  height: { xs: '350px', sm: '350px', md: '500px', lg: 'calc(var(--vh, 1vh) * 100)' },
};

export const mockupDevicesContainerSize = { xs: 12, sm: 12, md: 12, lg: 7, xl: 7 };
